var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { placement: "bottom-end", width: "300", trigger: "click" },
      model: {
        value: _vm.popShow,
        callback: function($$v) {
          _vm.popShow = $$v
        },
        expression: "popShow"
      }
    },
    [
      _c(
        "el-button",
        {
          attrs: { slot: "reference", size: "small", plain: "" },
          slot: "reference"
        },
        [
          _c("i", { staticClass: "el-icon-tickets" }),
          _vm._v("\n        Exportar Relatório\n    ")
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("h5", { staticClass: "font-weight-bold mb-3" }, [
            _vm._v("Relatórios")
          ]),
          _vm._v(" "),
          _c("el-divider", { staticClass: "mt-3" }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "distributorExport",
              attrs: {
                model: _vm.filters,
                "label-position": "top",
                "status-icon": ""
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column justify-content-center align-items-center"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "rounded d-flex justify-content-center align-items-center position-relative",
                      style: {
                        width: "64px",
                        height: "64px",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        borderColor: "#c2e7b0",
                        backgroundColor: "#f0f9eb"
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "bi bi-filetype-xls",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            fill: "#67C23A",
                            viewBox: "0 0 16 16"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              d:
                                "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM6.472 15.29a1.2 1.2 0 0 1-.111-.449h.765a.58.58 0 0 0 .254.384q.106.073.25.114.143.041.319.041.246 0 .413-.07a.56.56 0 0 0 .255-.193.5.5 0 0 0 .085-.29.39.39 0 0 0-.153-.326q-.152-.12-.462-.193l-.619-.143a1.7 1.7 0 0 1-.539-.214 1 1 0 0 1-.351-.367 1.1 1.1 0 0 1-.123-.524q0-.366.19-.639.19-.272.527-.422.338-.15.777-.149.457 0 .78.152.324.153.5.41.18.255.2.566h-.75a.56.56 0 0 0-.12-.258.6.6 0 0 0-.247-.181.9.9 0 0 0-.369-.068q-.325 0-.513.152a.47.47 0 0 0-.184.384q0 .18.143.3a1 1 0 0 0 .405.175l.62.143q.326.075.566.211a1 1 0 0 1 .375.358q.135.222.135.56 0 .37-.188.656a1.2 1.2 0 0 1-.539.439q-.351.158-.858.158-.381 0-.665-.09a1.4 1.4 0 0 1-.478-.252 1.1 1.1 0 0 1-.29-.375m-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94zm2.727 3.325H4.557v-3.325h-.79v4h2.487z"
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h5",
                    { staticClass: "font-weight-bolder text-center mt-2" },
                    [_vm._v("XLS")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            prop: "periodo",
                            rules: [
                              {
                                required: true,
                                message: "O período é obrigatório",
                                trigger: "change"
                              }
                            ]
                          }
                        },
                        [
                          _c("label", [_vm._v("Período")]),
                          _vm._v(" "),
                          _c("el-date-picker", {
                            attrs: {
                              "unlink-panels": "",
                              size: "small",
                              type: "daterange",
                              "start-placeholder": "Inicio",
                              "end-placeholder": "Fim",
                              format: "dd/MM/yyyy",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.filters.periodo,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "periodo", $$v)
                              },
                              expression: "filters.periodo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isAbleToExport
                    ? _c("el-col", { staticClass: "mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [
                            _vm.data.length == 1
                              ? _c("span", [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.data.length) +
                                        " Transação encontrada."
                                    )
                                  ])
                                ])
                              : _c("span", [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.data.length) +
                                        " Transações encontradas."
                                    )
                                  ])
                                ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-col", { staticClass: "mt-4" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-end" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              plain: "",
                              size: "large",
                              circle: "",
                              disabled: !_vm.isAbleToExport
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.handleClearExport.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [_c("i", { staticClass: "el-icon-delete" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "export-excel",
                          {
                            key: _vm.exportKey,
                            class: [
                              "el-button el-button--large rounded-pill",
                              !_vm.isAbleToExport
                                ? "is-plain el-button--default"
                                : "el-button--success"
                            ],
                            style: { width: "100%" },
                            attrs: {
                              data: _vm.data,
                              fields: _vm.headerExcel,
                              "before-generate": _vm.exportReport,
                              worksheet: "Distribuidores",
                              name: _vm.generateNameFile
                            }
                          },
                          [
                            _vm.isLoading
                              ? _c("i", { staticClass: "el-icon-loading" })
                              : _c("i", { staticClass: "el-icon-tickets" }),
                            _vm._v(" "),
                            _vm.isAbleToExport
                              ? _c("span", [_vm._v("Exportar relátorio")])
                              : _c("span", [_vm._v("Preparar relátorio")])
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51bcd7a0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51bcd7a0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/indicados/distribuidores_indicados/Export.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-51bcd7a0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/indicados/distribuidores_indicados/Export.vue
// module chunks = 2